<template>
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</template>

<script>
export default{
  name: 'Loader',
  props: [],
  data () {
    return {}
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Loader.vue